import {Component, Input, OnInit} from '@angular/core';
import {Route, Router, RouterLink, RouterLinkActive} from "@angular/router";
import {IconComponent} from "../icon/icon.component";
import {StyleClassModule} from "primeng/styleclass";
import {ButtonDirective} from "primeng/button";
import {NgClass} from "@angular/common";

@Component({
    selector: '[menuitem]',
    standalone: true,
    imports: [
        IconComponent,
        StyleClassModule,
        RouterLink,
        ButtonDirective,
        RouterLinkActive,
        NgClass
    ],
    templateUrl: './menuitem.component.html',
    styleUrl: './menuitem.component.scss'
})
export class MenuitemComponent implements OnInit {
    @Input() route!: Route;
    @Input() isRoot?: boolean = false;
    @Input() parentRouterLink: string[] = [];

    protected elementOpen: boolean = false;
    protected routerLink: string[] = [];

    constructor(
        private router: Router
    ) {
    }

    ngOnInit(): void {
        if (this.route!.path) {
            this.routerLink = [
                ...this.parentRouterLink,
                this.route.path
            ];
        }

        setTimeout(() => {
            this.isActive();
        }, 2500);
    }

    hasVisibleChildren() {
        return this.route.children?.some(childRoute => {
            return childRoute.data && childRoute.data['showInMenu'];
        });
    }

    isActive() {
        return this.router.url.startsWith('/' + this.parentRouterLink.join('/'));
    }
}
